import React from "react";
import svg from "./add.svg"
export function AddIcon() {
    return (
            <img src={svg} alt="hinzufügen" />
    );
}